const bytesInMB = 1024;

export default function bytesToMB(bytes: number): number {
    return Math.ceil(bytes / (bytesInMB * bytesInMB));
}
